module.exports = __webpack_public_path__ + "static/mdm-9a78e5a1f801ebac727ef4cbf5176221.png";